const topics = [
  { name: '# 流浪地球3', heat: '98.6万', trending: true },
  { name: '# 长安十二时辰', heat: '87.3万', trending: true },
  { name: '# 繁花沪语版', heat: '76.1万', trending: false },
  { name: '# 漫长的季节', heat: '65.8万', trending: true },
  { name: '# 鱿鱼游戏第二季', heat: '58.2万', trending: false },
  { name: '# 去有风的地方', heat: '52.4万', trending: false },
  { name: '# 庆余年', heat: '47.9万', trending: true },
  { name: '# 鬼灭之刃', heat: '43.5万', trending: true },
  { name: '# 猎罪图鉴2', heat: '38.7万', trending: false },
  { name: '# 三体电视剧', heat: '35.1万', trending: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            大家都在讨论的热门影视话题，看看有没有你感兴趣的
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#cards"
              className="inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300/50 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer no-underline group"
            >
              <span className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
              {topic.trending && (
                <span className="flex items-center gap-0.5 text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                  <i className="ri-fire-line text-[10px]"></i>
                  热
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}